<template>
  <div class="course-edit">
    <el-dialog
      width="400px"
      :visible="dialogFormVisible"
      title="修改科目信息"
      @open="dialogOpen"
      @close="dialogClose"
      :close-on-click-modal="false"
      :append-to-body="true"
      center
    >
      <el-form :model="formData" :rules="rules" ref="ruleForm">
        <el-form-item label="科目名称" label-width="100px" prop="courseName">
          <el-input
            v-model="formData.courseName"
            autocomplete="off"
            style="width: 235px"
          ></el-input>
        </el-form-item>
        <el-form-item label="科目类别" label-width="100px" prop="courseType">
          <!-- <el-input
            v-model="formData.courseType"
            autocomplete="off"
          ></el-input> -->
          <el-select
            v-model="formData.courseType"
            placeholder="选择类别"
            @change="typeSelect"
            clearable
          >
            <el-option
              v-for="item in typeSelectList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialogFormVisible: {
      type: Boolean,
      require: true,
    },
    courseInfo: {
      type: Object,
    },
    typeSelectList: {
      type: Array,
    },
  },
  // inject: ["refresh"],
  data() {
    return {
      formData: {
        courseName: "",
        courseType: "",
        id: "",
      },
      rules: {
        courseName: [{ required: true, message: "请输入科目名称", trigger: "blur" }],
        courseType: [{ required: true, message: "请输入科目类别", trigger: "change" }],
      },
    };
  },
  methods: {
    typeSelect(e) {
      this.formData.courseType = e;
    },
    dialogOpen() {
      // console.log("courseInfo==>", this.courseInfo);
      let { courseName, courseType, id } = this.courseInfo;
      this.formData.courseName = courseName;
      this.formData.courseType = "" + courseType;
      this.formData.id = id;
    },
    dialogClose() {
      // let { courseName, courseType } = this.studentInfo;
      // this.formData.courseName = studentName;
      // this.formData.courseType = studentNumber;
      this.$emit("update:dialogFormVisible", false);
    },
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // console.log("验证成功,下一步");
          // console.log("this.formData=> ", this.formData);
          this.$emit("editCourse", this.formData);
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
